export { analyzeCoalitions, isWinning, majorityThreshold } from './coalitions.js';
export { allocateCommittee, dHondt } from './committees.js';
export { analyzeMarginals } from './marginal.js';
export { allocateSeats, divisorFor } from './sainteLague.js';
export { findSeatTransfer } from './transfer.js';
/** Jämkade uddatalsmetoden, svensk standard sedan 2018. */
export const FIRST_DIVISOR_SE = 1.2;
/**
 * Ale kommunfullmäktige, mandatperioden 2026–2030: 51 mandat. Ale
 * kommunfullmäktige beslutade om ökningen (från 49) under 2025/2026.
 * Valmyndighetens egen data för valet 2026 speglar ännu inte detta – deras
 * `totaltAntalMandat`-fält visar 49 – så `api/src/valmyndigheten.ts` litar på
 * den här konstanten framför det fältet specifikt för valdatum 2026-09-13.
 */
export const ALE_KF_2026 = {
    seats: 51,
    firstDivisor: FIRST_DIVISOR_SE,
    /** Ale har en enda valkrets → 2 % småpartispärr. */
    thresholdPct: 2,
};
//# sourceMappingURL=index.js.map